export enum TranslationType {
  BPA = "BPA" as any,
  DS = "DS" as any,
  STATISTICS = "STATISTICS" as any,
  SERVICE = "SERVICE" as any,
}
